import React, { useState, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, List as ListComponent, useDrawer, Confirm, SplitButton } from 'src/mtska-frontend-app-component';
import { useGridApiRef } from '@mui/x-data-grid';
import { useDataProvider } from 'src/mtska-frontend-data-provider';

import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks';

const dataImportProviderName = 'renters/installed';
const dataProviderName = 'renters/installed';
const drawerRouteBase = 'rentersinstalled';

const moduleName = "Installed";

const List = (params) => {
    const { t } = useTranslation();
    const { userCapabilities, appConfiguration } = useContext(AppContext);
    const { activate } = useDrawer();
    const [importerVersion, setImporterVersion] = useState(appConfiguration.importer.version ?? null);

    const apiRef = useGridApiRef();
    const getSelected = () => {
        return [...apiRef.current.getSelectedRows()].map(([name]) => name);
    };
    const [selected, setSelected] = useState([]);
    const handleRowSelection = (newSelection) => {
        setSelected(newSelection);
        params.rowSelectionExternalListener && params.rowSelectionExternalListener(newSelection);
    };

    // const getFunctionalButtons = useMemo(() => {
    //     let rb = [];

    //     if (userCapabilities && userCapabilities[dataProviderName + '.delete'] && selected.length) {
    //         rb.push(
    //             <Button
    //                 disabled={userCapabilities && !userCapabilities[dataProviderName + '.delete']}
    //                 onClick={() => { handleDelete(); }}
    //                 label={t("Delete") + " (" + selected.length + ")"}
    //                 icon={"faTrash"}
    //                 variant="outlined"
    //                 size="small"
    //                 className="button-delete"
    //             />
    //         );
    //     }

    //     return rb;
    // }, [selected, userCapabilities]);


    // const [confirmDelete, setConfirmDelete] = useState();
    // const handleDelete = () => {
    //     setConfirmDelete(
    //         <Confirm
    //             oklabel={t("Delete")}
    //             okcallable={async () => {
    //                 doAction && await doAction({ action: wizardAction, model: dataProviderName, data: getSelected() });
    //                 setConfirmDelete(null);
    //                 apiRef.current.setRowSelectionModel([]);
    //                 loadAll();
    //             }}
    //             kolabel={t("Cancel")}
    //             kocallable={() => { setConfirmDelete(null) }}
    //             title={t("Items elimination")}>
    //             {t("Are you sure to remove the selected elements?")}
    //         </Confirm>
    //     );
    // }

    const { doAction, loadAll, items, total, loading, download, downloading, reloadCounter } = useDataProvider(dataProviderName);
    const [listFilterPageSort, setListFilterPageSort] = useState();
    const handleFilterPageSortChange = (model) => {
        setListFilterPageSort(model);
    }

    useLoadAll({ listFilterPageSort, loadAll, params, reloadCounter })

    const handleRowDoubleclick = (row) => {
        activate(drawerRouteBase + '/detail', { id: row.id });
    }

    const handleDownload = () => {
        download()
    }

    return (
        <>
            {userCapabilities && userCapabilities[dataProviderName + '.list'] && (
                <ListComponent
                    {...params}
                    onRowDoubleClick={(userCapabilities && userCapabilities[dataProviderName + '.view']) ? handleRowDoubleclick : () => { }}
                    onFilterPageSortChange={handleFilterPageSortChange}
                    items={items}
                    total={total}
                    loading={loading}
                    apiRef={apiRef}
                    enableSelection
                    rightButtons={[
                        <SplitButton
                            selectedItems={selected}
                            actions={[
                                // {
                                //     disabled: userCapabilities && !userCapabilities[dataProviderName + '.create'],
                                //     icon: "faAdd",
                                //     label: t('New'),
                                //     onClick: () => {
                                //         activate(drawerRouteBase + '/create', {
                                //             detailStack: params.detailStack ?? {},
                                //             relatedElements: params.relatedElements ?? {}
                                //         });
                                //     }
                                // },
                                {
                                    disabled: userCapabilities && !userCapabilities[dataProviderName + '.import'],
                                    icon: "faDownload",
                                    label: t('Import'),
                                    onClick: () => {
                                        activate('imports/list', {
                                            filters_original: {
                                                items: [{
                                                    operator: "equals",
                                                    field: "model",
                                                    value: dataProviderName,
                                                }]
                                            },
                                            filters: { items: selected },
                                            configDataProviderName: dataProviderName,
                                            currentDataProviderName: importerVersion === "ImporterFileMappingConstants" ? dataImportProviderName : dataProviderName,
                                            moduleName: moduleName,
                                        });
                                    }
                                },
                                // {
                                //     disabled: userCapabilities && !userCapabilities[dataProviderName + '.export'],
                                //     disabledIfNoItemselected: false,
                                //     icon: "faUpload",
                                //     label: t('Export'),
                                //     onClick: () => {
                                //         activate(
                                //             'wizards/download',
                                //             {
                                //                 dataProviderName: dataProviderName,
                                //                 recipe: 'recipes.advertisingcosts.global',
                                //                 recipes: {
                                //                     'wysiwyg': 'Your current view',
                                //                     'recipes.advertisingcosts.global': 'Global view',
                                //                 }
                                //             },
                                //         )
                                //     }
                                // },
                                // {
                                //     disabled: userCapabilities && !userCapabilities[dataProviderName + '.delete'],
                                //     disabledIfNoItemselected: true,
                                //     icon: "faTrash",
                                //     label: t('Delete'),
                                //     onClick: () => {
                                //         activate(
                                //             'wizards/delete',
                                //             {
                                //                 items: selected,
                                //                 dataProviderName: dataProviderName
                                //             },
                                //             (data) => {
                                //                 if (!data?.success) return;
                                //                 setSelected([]);
                                //             }
                                //         )
                                //     }
                                // }
                            ]}
                        />,
                    ]}
                    dataProviderName={dataProviderName}
                    title={moduleName}
                    rowSelectionExternalListener={handleRowSelection}
                    doAction={doAction}
                    treeData
                />
            )}
        </>
    );
};

export default List;


